// assets/cm-cart-cross-sell.js
(() => {
  const SECTION_ID = 'cm-cart-cross-sell';
  const TARGET_SELECTOR =
    '.drawer__content [mode="metafield_first_in_cart"][metafield="custom.cart_drawer_cross_sell_produkt"]';

  let busy = false;

  const fetchSectionHtml = async () => {
    const url = `${window.location.pathname}?sections=${encodeURIComponent(SECTION_ID)}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Cross sell fetch failed: ${res.status}`);
    const json = await res.json();
    return json[SECTION_ID] || '';
  };

  const extractBlock = (sectionHtml) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = sectionHtml;

    // Vi vil kun have selve blocken – ikke wrapper/section
    return tmp.querySelector('[data-cm-cart-cross-sell]');
  };

  const inject = (blockEl) => {
    const target = document.querySelector(TARGET_SELECTOR);
    if (!target) return;

    // Hvis der ikke er noget at vise, så fjern placeholderen
    if (!blockEl) {
      target.remove();
      return;
    }

    // VIGTIGT: swap hele placeholder-noden (ikke innerHTML)
    target.replaceWith(blockEl);
  };

  const run = async () => {
    if (busy) return;
    busy = true;

    try {
      const sectionHtml = await fetchSectionHtml();
      const blockEl = extractBlock(sectionHtml);
      inject(blockEl);
    } catch (e) {
      // hold den stille i production – men log til dev
      console.warn('[cm-cart-cross-sell]', e);
    } finally {
      busy = false;
    }
  };

  // Kør når cart drawer opdateres
  document.addEventListener('cart:fetched', run);

  // Fallback: kør ved load (hvis drawer allerede er åben / theme trigger ikke event)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  // Optional: hvis drawer DOM bliver re-rendered uden event, så catch det her
  const mo = new MutationObserver(() => {
    // Kun hvis placeholderen findes (ellers spammer vi ikke)
    if (document.querySelector(TARGET_SELECTOR)) run();
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
